export const collaboratorsData = [
  {
    id: 1,
    img: "",
    writtenBy: "Shanti Singh",
    writterPosition: "Lead Writer",
  },

  {
    id: 2,
    editorImg: "",
    editedBy: "Priya K.",
    editorPosition: "Lead Assigning Editor",
  },
];
